/**
 * Reparaturen (Fachmodul "repairs"): Status, Uebergaenge, Bezeichnungen.
 *
 * Ein Reparaturauftrag ist ein Vorgang mit Lebenslauf:
 *
 *   received    - Geraet angenommen, Fehlerbild erfasst
 *   quote_sent  - Kostenvoranschlag beim Kunden, wartet auf Freigabe
 *   approved    - vom Kunden freigegeben
 *   declined    - Kostenvoranschlag abgelehnt, Geraet geht zurueck
 *   in_repair   - in Arbeit
 *   completed   - fertiggestellt; Materialverbrauch ist gebucht
 *   closed      - Geraet zurueckgegeben, Vorgang beendet
 *
 * Arbeitszeit ist kein Sonderfall, sondern ein Artikel ohne
 * Bestandsfuehrung (Standardstundensatz, Garantiestundensatz, Kulanz ...).
 * Dadurch laufen Kostenvoranschlag und Rechnung als ganz normale Belege
 * ueber den vorhandenen Belegablauf.
 *
 * Eigene Geraete (`repairType: 'internal'`) durchlaufen denselben
 * Lebenslauf ohne den Kostenvoranschlags-Zweig und ohne Rechnung.
 */
export const REPAIR_TYPE_LABELS = {
    customer: 'Kundengerät',
    internal: 'Eigenes Gerät',
};
export const REPAIR_STATUSES = [
    'received',
    'quote_sent',
    'approved',
    'declined',
    'in_repair',
    'completed',
    'closed',
];
export const REPAIR_STATUS_LABELS = {
    received: 'Angenommen',
    quote_sent: 'KV beim Kunden',
    approved: 'Freigegeben',
    declined: 'KV abgelehnt',
    in_repair: 'In Reparatur',
    completed: 'Fertiggestellt',
    closed: 'Abgeschlossen',
};
/**
 * Erlaubte Statuswechsel. `closed` ist endgueltig - fuer ein Geraet, das
 * erneut hereinkommt, wird ein neuer Vorgang angelegt, damit die Historie
 * des alten unangetastet bleibt.
 */
export const REPAIR_TRANSITIONS = {
    received: ['quote_sent', 'approved', 'in_repair', 'declined'],
    quote_sent: ['approved', 'declined'],
    approved: ['in_repair'],
    declined: ['closed'],
    in_repair: ['completed'],
    completed: ['in_repair', 'closed'],
    closed: [],
};
/** Solange duerfen die Positionen geaendert werden. */
export const REPAIR_EDITABLE_STATUSES = [
    'received',
    'quote_sent',
    'approved',
    'in_repair',
];
//# sourceMappingURL=repairs.js.map